export default __webpack_public_path__ + "static/media/boxtype8.34703fdd.JPG";